const API_BASE_URL = process.env.REACT_APP_API_URL || "";
const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");
export const PLACEHOLDER_IMAGE = "https://placehold.co/400";

export const parseImageList = (value) => {
  if (Array.isArray(value)) {
    return value
      .filter((image) => typeof image === "string" && image.trim())
      .map((image) => image.trim());
  }

  if (typeof value !== "string" || !value.trim()) return [];

  const trimmed = value.trim();
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed !== value) return parseImageList(parsed);
  } catch {}

  return trimmed.includes(",")
    ? trimmed
        .split(",")
        .map((image) => image.trim())
        .filter(Boolean)
    : [trimmed];
};

export const getImageUrl = (url) => {
  if (!url || typeof url !== "string") return PLACEHOLDER_IMAGE;

  const trimmed = url.trim();
  if (!trimmed.startsWith("http://") && !trimmed.startsWith("https://")) {
    if (!API_ORIGIN) return trimmed;
    return `${API_ORIGIN}/${trimmed.replace(/^\/+/, "")}`;
  }

  return trimmed;
};

export const getProductImage = (product) => {
  const images = getProductImages(product);
  return images[0] || PLACEHOLDER_IMAGE;
};

// Cart lines can carry a dedicated variant image that should take precedence
// over the product image list (especially for older persisted cart entries).
export const getCartImage = (item) =>
  parseImageList(item?.image)[0] || getProductImage(item);

export const getProductImages = (product) => {
  if (!product) return [PLACEHOLDER_IMAGE];

  const images = parseImageList(product.images);
  if (images.length > 0) return images;

  const image =
    parseImageList(product.image)[0] || parseImageList(product.imageUrl)[0];
  return image ? [image] : [PLACEHOLDER_IMAGE];
};

export const getCategoryImage = (category) => {
  if (!category) return PLACEHOLDER_IMAGE;

  if (category.image_url) return category.image_url;
  if (category.image) return category.image;

  return PLACEHOLDER_IMAGE;
};
